import { paletteBase } from '@abg/kit-base';

export const DIVIDER_PALETTE_MAP = {
  budget: {
    light: paletteBase.skyBlue,
    dark: paletteBase.neutral300,
  },
  avis: {
    light: paletteBase.lightgrey,
    dark: paletteBase.ashGrey,
  },
  budgettruck: {
    light: paletteBase.skyBlue,
    dark: paletteBase.neutral300,
  },
} as const;
